export default "__VITE_ASSET__8m8xiQzi__"